module.exports = __webpack_public_path__ + "static/background-4bfd6bf6f157692cea003ccca9a20307.svg";